import { jsx as t } from "react/jsx-runtime";
import { Hotkey as r } from "../../Hotkey/index.js";
import { Pill as n } from "../../Pill/index.js";
import '../../../assets/index41.css';const c = "_ItemDecorationRight_1ub18_1", o = {
  itemDecorationRight: c
}, h = ({ hotkeyProps: i, pillProps: e }) => i ? /* @__PURE__ */ t("div", { className: o.itemDecorationRight, children: /* @__PURE__ */ t(r, { ...i }) }) : e ? /* @__PURE__ */ t("div", { className: o.itemDecorationRight, children: /* @__PURE__ */ t(n, { ...e }) }) : null;
export {
  h as ItemDecorationRight
};
//# sourceMappingURL=index.js.map
